import httpClient from "@/services/httpClient";
import {
    server
} from "@/services/constants";

export const getAllCountry = () => {
    return httpClient.get(server.COUNTRY + `/getAll`);
};